import React from 'react'
import './BulkProgressToast.sass'

const BulkProgressToast: React.FC<{
    title: string
    processed: number
    total: number
    failed: number
    currentItemName?: string
}> = ({ title, processed, total, failed, currentItemName }) => {
    const percentage = total > 0 ? Math.round((processed / total) * 100) : 0

    return (
        <div className="bulk-progress-toast">
            <div className="bulk-progress-toast__header">
                <span className="bulk-progress-toast__title">{title}</span>
                <span className="bulk-progress-toast__count">
                    {processed} di {total}
                </span>
            </div>
            <div
                className="bulk-progress-toast__track"
                role="progressbar"
                aria-label={title}
                aria-valuemin={0}
                aria-valuemax={total}
                aria-valuenow={processed}
                aria-valuetext={`${processed} di ${total}`}
            >
                <div className="bulk-progress-toast__bar" style={{ transform: `scaleX(${percentage / 100})` }} />
            </div>
            {currentItemName && <span className="bulk-progress-toast__current">{currentItemName}</span>}
            {failed > 0 && (
                <span className="bulk-progress-toast__failed">
                    {failed} {failed === 1 ? 'eliminazione non riuscita' : 'eliminazioni non riuscite'}
                </span>
            )}
            <span className="bulk-progress-toast__hint">Non chiudere né ricaricare la pagina fino al termine.</span>
        </div>
    )
}

export default BulkProgressToast
